/**
 * What to call an import batch in a list. An upload is named for its file; a fetch from the API has
 * no file, and calling it "Upload 12" would claim somebody uploaded it.
 */
export default function importBatchName(batch) {
	if(batch.filename) {
		return batch.filename;
	}
	const fetched = batch.origin === 'api' || batch.origin === 'api_fetch';
	return fetched ? `Fetched from Monarch (#${batch.id})` : `Upload ${batch.id}`;
}
